import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Container, Typography, Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import PropTypes__default from 'prop-types';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import CustomRichText from '../../common/CustomRichText.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { retrieveContentfulImage } from '../../common/image.js';

var useStyles = makeStyles(function (theme) {
  return {
    title: {
      background: "linear-gradient(bottom, ".concat(theme.palette.primary[100], " 60%, transparent 40%)"),
      display: "inline"
    },
    subtitle: _defineProperty({
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(5)
    }, theme.breakpoints.down("xs"), {
      marginBottom: theme.spacing(4)
    }),
    icon: {
      width: theme.spacing(6.25),
      height: theme.spacing(6.25)
    },
    itemContainer: _defineProperty({
      gridRowGap: theme.spacing(7)
    }, theme.breakpoints.down("xs"), {
      textAlign: "center"
    }),
    item: _defineProperty({}, theme.breakpoints.up("xs"), {
      paddingRight: theme.spacing(3)
    }),
    itemText: {
      color: theme.palette.primary[900]
    }
  };
});
var FactsFigures = function FactsFigures(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    elements = _ref.elements,
    gridColumns = _ref.gridColumns,
    bgColor = _ref.bgColor;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    px: 3,
    pt: isExtraSmallScreen() ? 8 : 11,
    pb: isExtraSmallScreen() ? 2 : 4
  }, /*#__PURE__*/React__default.createElement(Container, {
    disableGutters: true
  }, /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.title,
    variant: "h1",
    component: "h2"
  }, title ? title : /*#__PURE__*/React__default.createElement(Skeleton, null)), /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.subtitle,
    variant: "body1"
  }, subtitle ? subtitle : /*#__PURE__*/React__default.createElement(Skeleton, null)), /*#__PURE__*/React__default.createElement(Grid, {
    className: classes.itemContainer,
    container: true
  }, elements && (elements === null || elements === void 0 ? void 0 : elements.map(function (e) {
    return /*#__PURE__*/React__default.createElement(Grid, {
      className: classes.item,
      key: e.key,
      item: true,
      xs: 12,
      sm: 6,
      md: gridColumns ? 12 / gridColumns : 4
    }, (e === null || e === void 0 ? void 0 : e.imageUrl) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.icon,
      src: retrieveContentfulImage(e.imageUrl, {
        width: 50,
        height: 50
      }),
      alt: (e === null || e === void 0 ? void 0 : e.imageTitle) || ""
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h1",
      component: "div",
      className: classes.itemText
    }, e.text), (e === null || e === void 0 ? void 0 : e.description) && /*#__PURE__*/React__default.createElement(CustomRichText, {
      document: e.description
    }));
  })))));
};
FactsFigures.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  elements: PropTypes__default.array,
  gridColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12])
};

export { FactsFigures as default };
//# sourceMappingURL=FactsFigures.js.map
